<template>
  <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey py-4 no-ws text-center">
    <template v-for="(menu,index) in stepper">
      <div class="d-inline-block align-middle">
        <div class="be-step-cart mr-lg-2 d-lg-inline-block d-block align-middle mb-lg-0 mb-2 mx-auto" :class="{'active':menu.id <= step}">
          <span class="body-2-4" v-if="menu.id >= step"
            :class="{'text-white': menu.id == step }">{{ menu.id }}</span>
          <div v-else style="line-height: 35px;">
            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.79995 10.9L1.59995 6.7L0.199951 8.1L5.79995 13.7L17.8 1.7L16.4 0.300003L5.79995 10.9Z"
                fill="#fff" />
            </svg>
          </div>
        </div>
        <p class="mb-0 d-lg-inline-block d-block align-middle stepper-text"
          :class="{'active':menu.id == step}">{{ menu.name }}</p>
      </div>
      <div class="d-inline-block align-middle mx-sm-4 mx-3 px-sm-3 px-0" v-if="(index+1) < stepper.length">
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8.74994 20.414L7.33594 19L14.3359 12L7.33594 5L8.74994 3.586L17.1639 12L8.74994 20.414Z"
            fill="#222" />
        </svg>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      step:{
        type: Number,
        default: 1
      },
      need_payment: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        stepper: [{
            id: 1,
            name: 'Select Service'
          },
          {
            id: 2,
            name: 'Fill in data'
          },
          {
            id: 3,
            name: "Payment"
          }
        ],
      }
    },
    watch:{
      need_payment(){
        this.changeLastStepTitle()
      }
    },
    mounted(){
      this.changeLastStepTitle()
    },
    methods:{
      changeLastStepTitle(){
        this.stepper[2].name = this.need_payment ? 'Payment' : 'Complete'
      }
    }
  }
</script>
<style>
  .be-step-cart {
    width: 35px;
    height: 35px;
    background-color: #ececec;
    border-radius: 50%;
    border: 1px solid #9f9f9f;
    text-align: center;
  }

  .be-step-cart>span {
    line-height: 35px !important;
  }

  .be-step-cart.active {
    background-color: var(--merchant-primary-color);
    border: 1px solid var(--merchant-primary-color);
  }
  

  .be-step-cart.active-mobile {
    background-color: #fff;
    border: 1px solid #fff;
  }
  .stepper-text{
    font-size: 12px !important;
    font-family: Nunito-Bold;
    color: #222222;
    letter-spacing: 0.25px;
  }
  
  .stepper-text.active{
    color: var(--merchant-primary-color)
  }

  @media (min-width: 576px) {
  .stepper-text{
    font-size: 14px !important;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/general/stepper.vue